import useTranslations from 'i18n/useTranslations';
import React from 'react'

const EmptyCoupon = () => {
    const { t } = useTranslations();
    return (
        <div className="bCouponNone">
            <div className="bText">
            <i></i>
            <p>{t.coupon.noCoupon}</p>
            </div>
        </div>
    )
}

export default EmptyCoupon